import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { isNotAvailableDisplay, NOT_AVAILABLE_I18N_KEY } from '../../../core/utils/utils';
import { formatPhoneDisplay } from '../../../processes/utils/sent-messages.util';
import { resolveTfaPhone, TfaPhoneChannelSource } from '../../../operations/utils/tfa-display.util';

/**
 * Teléfono formateado (`+34 600 111 222`).
 * - `[phone]`: valor crudo.
 * - `[tfa]`: resuelve con `resolveTfaPhone` (raíz o última comunicación).
 * Vacío / N/D → `emptyText` o clave i18n `GENERAL.NOT_AVAILABLE`.
 */
@Component({
	selector: 'app-phone-display',
	standalone: true,
	imports: [TranslatePipe],
	template: `@if (formattedPhone; as phone) {
		{{ phone }}
	} @else {
		{{ emptyText || (emptyI18nKey | translate) }}
	}`,
})
export class PhoneDisplayComponent {
	/** Teléfono en crudo (E.164, dígitos, etc.). Ignorado si hay `[tfa]`. */
	@Input() phone: string | null | undefined;

	/** Sesión/data TFA: resuelve teléfono vía `resolveTfaPhone`. */
	@Input() tfa: TfaPhoneChannelSource | null | undefined;

	/** Texto cuando no hay teléfono. Si no se pasa, se usa `GENERAL.NOT_AVAILABLE`. */
	@Input() emptyText?: string;

	/** Clave i18n por defecto para vacío (sobreescribible si hace falta). */
	public readonly emptyI18nKey = NOT_AVAILABLE_I18N_KEY;

	/** Teléfono ya formateado, o `null` si hay que mostrar el vacío. */
	public get formattedPhone(): string | null {
		const raw = this.resolveRawPhone();
		if (!raw || isNotAvailableDisplay(raw)) {
			return null;
		}
		return formatPhoneDisplay(raw);
	}

	private resolveRawPhone(): string {
		if (this.tfa != null) {
			return resolveTfaPhone(this.tfa);
		}
		return this.phone?.trim() ?? '';
	}
}
